/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOwnFundVariantDto } from '../../models/backend-own-fund-variant-dto';

export interface FinancingSourcesOwnFundsVariantsRetrieve$Params {
  /**
   * A unique integer value identifying this own fund variant.
   */
  id: number;
}

export function financingSourcesOwnFundsVariantsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesOwnFundsVariantsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesOwnFundsVariantsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOwnFundVariantDto>;
    }),
  );
}

financingSourcesOwnFundsVariantsRetrieve.PATH = '/api/financing_sources/own_funds_variants/{id}/';
